import React from 'react';
import { Search } from 'lucide-react';
interface SearchBarProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}
export function SearchBar({
  value,
  onChange,
  placeholder = 'Search employees...'
}: SearchBarProps) {
  return <div className="relative w-full" data-id="element-1455">
      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-slate-500" data-id="element-1456">
        <Search size={18} data-id="element-1457" />
      </div>
      <input type="text" value={value} onChange={e => onChange(e.target.value)} className="block w-full pl-10 pr-3 py-2.5 border border-white/10 rounded-lg leading-5 bg-navy-800/60 backdrop-blur-sm placeholder-slate-500 text-white focus:outline-none focus:ring-2 focus:ring-accent-400/20 focus:border-accent-400/30 transition-all duration-200 sm:text-sm shadow-sm" placeholder={placeholder} data-id="element-1458" />
    </div>;
}